import { Component, OnInit,ViewChild,  EventEmitter, Output, ElementRef,Input} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { UserDetailModel, UpdateUserModel, ExistUserCheckModel } from 'src/app/viewModels/users/UserListModel';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import * as jwt_decode from 'jwt-decode';
import { UserService } from 'src/app/applicationModules/admin/users/services/user/user.service';
import { RoleService } from 'src/app/applicationModules/admin/roless/services/role.service';
import { MultiselectVM } from 'src/app/viewModels/common/multiselect-vm';
import { map, startWith } from 'rxjs/operators';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {
  @ViewChild('email', {static: true}) email:ElementRef;
  @ViewChild('firstname', {static: true}) firstname:ElementRef;
  organizationId: string;
  databaseId: string;
  userDetailform: FormGroup;
  userDetail: UserDetailModel = new UserDetailModel();
  updateUserDetail: UpdateUserModel = new UpdateUserModel();
  existingUser: ExistUserCheckModel = new ExistUserCheckModel();
  titleAlert = 'This field is required';
  isEdit: boolean;
  hide = true;
  selectedroles: any[];
  roles: any[];
  UserRoles: any[];
  phoneNumberExt: string;
  dialogTitle: string;
  createUserResponseHolder: any;
  isActiveChecked : boolean = true;
  closePannel:boolean = false;
  rolesResponseHolder: any;
  currentUser: any;
  officectrl = new FormControl();
  getUserListModelCreate={
     search : '',
    pageSize: 0,
    pageIndex: 0,
    databaseID: 0,
    organizationID: 0,
    roleLevel:0,
  }
  @Output() closeSidePanel = new EventEmitter();
  @Output() closeSidePanelAfterSave = new EventEmitter();  
  offices: any;
  searchOffice: any=[];
  selectedOfficeArray: any=[];
  OfficeIDList: any=[];
  myOfficeID: any;
  dropdownSettings = {};
  dropdownList: any[] = [];
  selectedItems = []; 
  orgDetails:any;
  officeName:string="";
  isHeadOffice:boolean=false;
  childOffice:boolean=false;
  @Input() SelectedRole: number=0;

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrlValue:string;
  objectList:any=[]=[];

  tempArrayToHoldPermission: any[] = [];
  spinner:boolean=false;
  @Output() getcloseCreateRole = new EventEmitter<boolean>();

  constructor(private formBuilder: FormBuilder, private customValidator: CustomvalidationService,
    private _userService: UserService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, public _matDialog: MatDialog, private statusConst: StatusConstant,
    private loaderService: LoaderService, private toastr: ToastrService, 
    private rolesService: RoleService, private paginationVm: PaginationViewModel,
    private mulstiselect: MultiselectVM) {   
    this.createForm();
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.getUserListModelCreate.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getUserListModelCreate.organizationID = parseInt(sessionStorage.getItem('organizationID'));
    this.orgDetails = JSON.parse(sessionStorage.getItem("orgdetail"));
    this.isActiveChecked=true;

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );  
  }

  states= this.objectList;

  private _filterStates(value: string): State[] {    
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnInit(): void {    
   // Role Office Admin -3 , Organization Admin-2
    this.SelectedRole;
    this.isActiveChecked=true;
    this.firstname.nativeElement.focus();   
    this.paginationVm.pageIndex = 0;
    this.paginationVm.pageSize = 0;
    this.addPrefix();   
    this.getRolesList();

    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: true,
      allowSearchFilter: true
    };

    this.officeName =this.orgDetails.officeName;
    this.myOfficeID = this.orgDetails.officeID;    
  }
    

  // Create Register User Form
  createForm(): void {
    const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;   
    this.userDetailform = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailregex)]],     
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      password: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
      confirmPassword: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern(phoneNumberregex)]],
      selectedroles: ['', Validators.required],
      isActive: true
    }, {
      validator: this.customValidator.mustMatch('password', 'confirmPassword')
    });
  }
  

  getRolesList() {
     if(this.SelectedRole==undefined || this.SelectedRole==null){
      this.SelectedRole=0;
    }
    var ReqModel={      
        searchKey: "",
        pageIndex: 0,
        pageSize: 0,
        databaseID: this.orgDetails.databaseID,
        organizationID: this.orgDetails.organizationID,
        searchValue: "",
        roleLevel: this.SelectedRole      
    }
    //this.getUserListModelCreate.organizationID=this.orgDetails.organizationID;   
    // if(this.SelectedRole==undefined || this.SelectedRole==null){
    //   this.SelectedRole=0;
    // }
    // this.getUserListModelCreate.roleLevel=this.SelectedRole;
    this.rolesService.getRoleList(ReqModel).subscribe(response=>{     
    if (response) {
      this.rolesResponseHolder = response;
      if (this.rolesResponseHolder.status == this.statusConst.statusSuccess) {      
        this.roles = this.rolesResponseHolder.data.roleModel;
        this.dropdownList=[];
        this.tempArrayToHoldPermission=[];
        this.roles.forEach(perm => {
         let copyModel = Object.assign({}, this.mulstiselect);
         copyModel.item_id = perm.roleID;
         copyModel.item_text = perm.roleName;
         this.tempArrayToHoldPermission.push(copyModel);
       });
       this.dropdownList = this.tempArrayToHoldPermission; 

       let tempArray = [];

       if(this.dropdownList.length>0 && this.SelectedRole!=0){       
         this.dropdownList.forEach(e => { 
         let copyModel = Object.assign({}, this.mulstiselect);
         copyModel.item_id = e.item_id;
         copyModel.item_text = e.item_text;
         tempArray.push(copyModel);      
         });
        this.selectedItems = tempArray;
       }        
      }
     }
    });
  }
  
  // To Register New User
  async save(data) {
    this.spinner=true;
    this.userDetailform.markAsPristine();   
    this.orgDetails = JSON.parse(sessionStorage.getItem("orgdetail"));
    try {
       //data.email = data.email.toLowerCase();
       var UserRoles= [];
       var offices=[];
       this.selectedItems.forEach(element => {
        UserRoles.push((element.item_id.toString()));    
       });

       if(this.isUserExist==true){
         offices.push(this.myOfficeID);
        if(this.OfficeUsingSelectedUser.length>0){
          this.OfficeUsingSelectedUser.forEach(element => {
            offices.push(Number(element.officeID));    
           });
        }     
       }else{
        offices.push(this.myOfficeID);
       }     

      var reqModels={
        userName : this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.email.toLowerCase()),
        email: this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.email.toLowerCase()),
        passwordHash : this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.password),
        phoneNumber: this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.phoneNumberExt + '' + data.phoneNumber),
        twoFactorEnabled :true,
        firstName: this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.firstname),
        lastName : this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.lastname),
        createdBy : this.currentUser.UID,
        isActive : (data.isActive !== true) ? false : data.isActive,     
        userRoles: UserRoles,       
        orgaizationID:  this.orgDetails.organizationID,
        databaseID: this.orgDetails.databaseID,
        offices: offices,
        myOfficeID : this.myOfficeID,
        isUserExist:this.isUserExist,
        uuid:this.selectedUserId,   
      }    
      //return;
      this.loaderService.show();
      const result = await this._userService.registerUser(reqModels).toPromise();
      this.createUserResponseHolder = result;
      this.loaderService.hide();
      this.spinner=false;
      if (this.createUserResponseHolder.status === this.statusConst.statusSuccess) {
        this.toastr.success("User Created successfully.", '', {
          timeOut: 3000,
        });
        let closePanel = true;
        this.closeSidePanelAfterSave.emit(closePanel);       
        this.userDetailform.reset();
        this.userDetailform.controls.isActive.setValue(true);     
      } else {
        this.spinner=false;
        this.loaderService.hide();
         this.toastr.warning("User already exist.", '', {
          timeOut: 3000,
        });       
      }
    } catch (e) {
      this.spinner=false;
      Observable.throw(e);
    }
  }
 

// To close the dialog popup
  close(any) {
    this.isUserExist=false;
    this.selectedUserId="";
    let closePanel = false;
    this.userDetailform.reset();
    this.userDetailform.controls.isActive.setValue(true);   
    this.closeSidePanel.emit(closePanel);    
    this.getcloseCreateRole.emit(any);
  }
   

  emailList:any=[]=[];
  timeout = null;
  responseHolder: any;
  anonymousEmail:any=[]=[];
  selectedUserId:string="";
  OfficeUsingSelectedUser:any=[]=[];
  selectedOrgorganizationID:number=0;
  isUserExist:boolean=false; 

  searchUser(val) {
    this.selectedUserId="";   
    this.isUserExist=false;
    this.OfficeUsingSelectedUser=[];   
    this.emailList=[];
      if(val.length>=2){       
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {      
       this.getAllEmail(val)
      }, 500);
    }else{
      this.selectedUserId="";
      this.isUserExist=false; 
      this.emailList=[];
      this.OfficeUsingSelectedUser=[];
      let  emailVerified:boolean=false;
      const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      emailVerified = regexp.test(val);
      if(emailVerified==true){
      this.userDetailform.patchValue({      
         email: val,
        });
      }else{
        this.userDetailform.patchValue({       
           email: val,
          });       
      }    
    }
  }


  getAllEmail(searchValue: any) {
    var ReqModel = {
      pageIndex : 500,
      pageSize: 0,
      searchKey: searchValue,
      databaseID : Number(this.databaseId),
      organizationID : Number(this.organizationId),
      userID: this.currentUser.UID,
      officeID: 0         
    }
    this._userService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.emailList = response.data.userModel;         
       
          if(this.emailList.length>0){
            this.emailList.map((res) => {
              if (res.email != null) {
                res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
              }
              if (res.phoneNumber != null) {
                res.phoneNumber = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.phoneNumber);
              }
              if (res.userName != null) {
                res.userName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.userName);
              }
              if (res.firstName != null || res.lastName != null) {
                res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.firstName);
                res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.lastName);
                res.name=res.firstName + " "+ res.lastName;
              }       
              return res;
            });
          }else{
            let  emailVerified:boolean=false;
            const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            emailVerified = regexp.test(searchValue);
            if(emailVerified==true){
            this.userDetailform.patchValue({            
               email: searchValue,
              });
            }
          }     
        }else{
          let  emailVerified:boolean=false;
          const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
          emailVerified = regexp.test(searchValue);
          if(emailVerified==true){
          this.userDetailform.patchValue({            
             email: searchValue,
            });
          }   
          this.selectedUserId="";
          this.isUserExist=false;             
          this.emailList=[];
        }
       }else{
          this.selectedUserId="";
          this.isUserExist=false;             
          this.emailList=[];
       }
     })
  }
 

 emailSelected(email: any) {
    this.selectedUserId=email.uuid;
    this.isUserExist=true;

    this.userDetailform.patchValue({     
      firstname: email.firstName,
      lastname: email.firstName,
      email: email.email, 
      phoneNumber: email.phoneNumber.substring(2)
     });

     this.OfficeUsingSelectedUser=[];
     
     if(email.offices.length>0){
      var check=[];
      check=email.offices.filter(x=>x.officeID==this.myOfficeID);
      if(check.length>0){        
        this.toastr.warning('Selected user is allready associated with '+check[0].officeName+' office.', '', {
          timeOut: 6000,
        });
        this.stateCtrl.reset();
        this.isUserExist=false;
        this.selectedUserId="";        
        this.userDetailform.reset();
        this.userDetailform.controls.isActive.setValue(true);         
        this.OfficeUsingSelectedUser=[];
        return;
      }else{
        for (let i = 0; i < email.offices.length; i++) {
          var ReqModel={
            officeName:email.offices[i].officeName,
            officeID:email.offices[i].officeID,
            userOfficeID:email.offices[i].userOfficeID,
          }
          this.OfficeUsingSelectedUser.push(ReqModel);
        }
      }
    
    }      
    
 }




 // show default extension in Phone Number extension field
 addPrefix() {
  this.phoneNumberExt = '+1';
}

 allowAlphabetOnly(event) {
  const regexp = new RegExp('^[0-9!@#$&()\\-`.+,/\"]*$');
  const result = regexp.test(event.key);
  if (result) {
    this.titleAlert = 'Please enter only alphabets';
    event.preventDefault();
    return false;
  }
}
  
// To match password on confirm password input box
matchPassword(): void {
  if (this.userDetailform.controls['password'].value !== this.userDetailform.controls['confirmPassword'].value) {
    this.userDetailform.controls['confirmPassword'].setErrors({ MatchPassword: true });
  } else {
    return null;
  }
}

// To check the existing user
checkInUseEmail(): void {
  this.existingUser.Email = this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.userDetailform.controls['email'].value);
  this._userService.checkExistingUser(this.existingUser).subscribe(result => {
    if (result.data) {
      this.userDetailform.controls['email'].setErrors({ alreadyInUse: true });
      this.getErrorEmail();
    } else {
      return null;
    }
  });
}

get name() {
  return this.userDetailform.get('name') as FormControl;
}

// Get Errors for email field
getErrorEmail() {
  return this.customValidator.getErrorEmail(this.userDetailform);
}

// Get Errors for password field
getErrorPassword() {
  return this.customValidator.getErrorPassword(this.userDetailform);
}

 // Get Errors for phoneNumber field
getPhoneErrorMessage() {
  return this.customValidator.getPhoneErrorMessage(this.userDetailform);
}


// To add the checkboxes in UserRole field
equals(objOne, objTwo) {
  if (typeof objOne !== 'undefined' && typeof objTwo !== 'undefined') {
    return objOne.id === objTwo.id;
  }
}



}

